import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'vi-icon-button',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatIconModule, MatButtonModule],
  templateUrl: 'icon-button.component.html',
  styleUrls: ['icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViIconButtonComponent {
  @Input() color: 'accent' | 'primary' | 'warn';
  @Input() icon: string;
  @Input() opacity: boolean;
}
